import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/warehouseStructure/warehouseSix/warehouseSix.webp";

function WarehouseSix(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
            <div className="warehouseSix">
              <h1 className={`${isVisible ? 'visible' : ''}`}>{t("warehouse_six_title")}</h1>
              <p className={`${isVisible ? 'visible' : ''}`}>
                {t("warehouse_six_text")}
              </p>
              <img className={`${isVisible ? 'visible' : ''}`} src={img1} alt="" width={'200px'} />
            </div>
        </VisibilitySensor>
    )
}
export default WarehouseSix;